import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Clock",
  "use": "Clock-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"Clock\">\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n        <g transform=\"translate(1.000000, 1.000000)\" stroke=\"currentColor\" stroke-width=\"2\">\n            <circle cx=\"10\" cy=\"10\" r=\"9.73684211\" />\n            <polyline points=\"15.4553865 10 10 10 10 4.1380551\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol